import React from 'react'
import { Box, Button, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    root: {
        position: 'relative',
        margin: -theme.spacing(1) * 2,
        marginBottom: theme.spacing(0),
        marginTop: theme.paper ? -theme.paper.paddingTop : -theme.spacing(1) * 3,
        [theme.breakpoints.up(600)]: {
            margin: -theme.spacing(1) * 4,
            marginTop: -theme.spacing(1) * 4,
            marginBottom: theme.spacing(1)
        }
    },
    headerImage: {
        maxWidth: '100%'
    },
    extraElementsLinkWrapper: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        display: 'flex'
    },
    extraElementsLink: {
        margin: 'auto',
        padding: '1px 6px',
        textTransform: 'none',
        color: 'white!important'
    },
    hideOnDesktop: {
        [theme.breakpoints.up(600)]: {
            display: 'none'
        }
    },
    questionPageLegendWrapper: {
        position: 'absolute',
        top: 0,
        width: '100%',
        display: 'flex'
    },
    questionPageLegend: {
        margin: 'auto',
        padding: theme.spacing(0.5, 2),
        background: 'white',
        borderBottomRightRadius: 4,
        borderBottomLeftRadius: 4,
        fontWeight: 600,
        color: theme.palette.primaryColor,
        fontFamily: theme.fontFamily,
        fontSize: '1rem',
        [theme.breakpoints.up(600)]: {
            fontSize: '1.2rem'
        }
    }
}))

function HeaderImage({ theme, questionPage }) {
    const classes = useStyles()

    if (!theme && !theme.headerImage) {
        return null
    }

    return (
        <div className={classes.root}>
            <img className={classes.headerImage} src={theme.headerImage} />
            {questionPage?.legend && (
                <Box className={classes.questionPageLegendWrapper}>
                    <Box className={classes.questionPageLegend}>{questionPage.legend}</Box>
                </Box>
            )}
            {false && theme?.is_extra_elements_visible == true && questionPage?.showFooter && (
                <Box className={classes.extraElementsLinkWrapper + ' ' + classes.hideOnDesktop}>
                    <Button variant="contained" size="small" color="primary" href="#information" className={classes.extraElementsLink}>
                        Osallistuminen on turvallista. Lue tästä miksi.
                    </Button>
                </Box>
            )}
        </div>
    )
}

export default HeaderImage
